// @ts-nocheck
import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions(
  {
    setFullPageLayout: ['payload'],
    setStep: ['payload'],
    addFile: ['payload'],
    removeFile: null,
    setColumnsAndRows: ['payload'],

    getSystemFieldsRequest: ['params'],
    getSystemFieldsSuccess: ['payload'],
    getSystemFieldsFailure: null,

    matchColumn: ['payload'],
    unmatchColumn: ['payload'],
    reset: null,

    checkUnidentifiedResourceAssignerRequest: ['params', 'payload'],
    checkUnidentifiedResourceAssignerSuccess: ['payload'],
    checkUnidentifiedResourceAssignerFailure: ['payload'],

    checkDefaultResourceAssignerRequest: null,
    checkDefaultResourceAssignerSuccess: ['payload'],
    checkDefaultResourceAssignerFailure: null,

    saveBulkResourceAssignerRequest: ['params', 'payload'],
    saveBulkResourceAssignerSuccess: ['payload'],
    saveBulkResourceAssignerFailure: null,

    saveResourceAssignerRequest: ['params', 'payload'],
    saveResourceAssignerSuccess: ['payload'],
    saveResourceAssignerFailure: null,

    setImportUnmatchedColumns: ['payload'],
    setImportUnidentifiedResourceAssigner: ['payload'],

    removeDuplicateRows: null,
    removeEmptyMandatoryFields: null,
    addSystemField: ['payload'],
  },
  { prefix: 'RESOURCE_ASSINGER_IMPORT/' },
);

export default Creators;
